import React from 'react';
import PropTypes from 'prop-types';
import {ALPHABET_LIST, STEP_STATE} from './StepItem.constants';
import HexagonIcon from '@learningblocks/exp-constants/lib/Icons/hexagon-outline';
import DisabledIcon from '@learningblocks/exp-constants/lib/Icons/alert-large-success';
import {Colours} from '@learningblocks/storybook-components';

export function StepNumber(props) {
  const renderIcon = () => {
    if (props.state === STEP_STATE.DISABLED) {
      return (
        <DisabledIcon className='icon' style={{fill: Colours.colorPrimary}} />
      );
    } else if (props.state === STEP_STATE.ACTIVE) {
      return (
        <HexagonIcon
          className='icon'
          style={{fill: Colours.colorNeutralWhite}}
        />
      );
    } else {
      return (
        <HexagonIcon className='icon' style={{fill: Colours.colorPrimary}} />
      );
    }
  };

  const renderLabel = () => {
    if (props.state !== STEP_STATE.DISABLED) {
      return <p className='label'>{ALPHABET_LIST[props.id]}</p>;
    } else {
      return null;
    }
  };

  const setClassName = () => `${props.className} ${props.state}`;

  return (
    <div className={setClassName()}>
      {renderIcon()}
      {renderLabel()}
    </div>
  );
}

StepNumber.propTypes = {
  /**
   * className for component
   */
  className: PropTypes.string,
  /**
   * Index of step [ will be translated to step label]
   */
  id: PropTypes.number,
  /**
   * State of the button [ disabled, active, inactive]
   */
  state: PropTypes.oneOf(['disabled', 'active', 'inactive']),
};

StepNumber.defaultProps = {
  state: 'inactive',
};
